var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoBannerStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 52,
    viewBox: "0 0 269 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H269L222.6 52H6C2.68629 52 0 49.3137 0 46V6Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M239.5 31.5L222.5 52H257L239.5 31.5Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.011 14.459C62.4577 12.4027 60.8365 10.7819 58.7806 10.2281C55.0244 9.2002 39.9995 9.2002 39.9995 9.2002C39.9995 9.2002 24.9751 9.2002 21.2189 10.189C19.2025 10.7423 17.5417 12.4031 16.9884 14.459C16 18.2148 16 26.0041 16 26.0041C16 26.0041 16 33.8325 16.9884 37.5492C17.5421 39.6051 19.163 41.2263 21.2192 41.78C25.0146 42.808 39.9999 42.808 39.9999 42.808C39.9999 42.808 55.0244 42.808 58.7806 41.8192C60.8369 41.2659 62.4577 39.6446 63.0114 37.5887C63.9998 33.8325 63.9998 26.0436 63.9998 26.0436C63.9998 26.0436 64.0394 18.2148 63.011 14.459Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2168 33.2002L47.7108 26.0042L35.2168 18.8081V33.2002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBannerStripe);
export default __webpack_public_path__ + "static/media/video-banner-stripe.940a6b79eff23c783b577cb90672724b.svg";
export { ForwardRef as ReactComponent };